"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CombinedChartIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "222",
  height: "179",
  viewBox: "0 0 222 179",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M21.323 169.858h15.699v-48.122h-15.7v48.122zm-5.287 7.391a5.282 5.282 0 01-5.287-5.279v-55.52a5.288 5.288 0 015.287-5.286h26.273a5.294 5.294 0 015.294 5.286v55.52c0 2.915-2.372 5.28-5.294 5.28H16.036z",
        fill: "#4BAF5E",
        className: "svg-fill-primary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M70.907 168.009h15.7V73.583h-15.7v94.426zm20.986 10.553H65.62c-2.922 0-5.294-2.361-5.294-5.273V68.303c0-2.912 2.372-5.281 5.294-5.281h26.273a5.285 5.285 0 015.287 5.28V173.29a5.279 5.279 0 01-5.287 5.273zM120.916 168.006h15.699v-50.224h-15.7v50.224zm20.985 10.556H115.63a5.28 5.28 0 01-5.287-5.274V112.5a5.28 5.28 0 015.287-5.275H141.9c2.923 0 5.295 2.362 5.295 5.275v60.788c0 2.912-2.372 5.274-5.295 5.274zM170.5 167.984h15.699V94.616H170.5v73.368zm20.986 10.578h-26.28a5.29 5.29 0 01-5.287-5.285V89.322a5.291 5.291 0 015.287-5.293h26.28a5.287 5.287 0 015.287 5.293v83.955a5.285 5.285 0 01-5.287 5.285zM78.972 10.52c-5.428 0-9.845 4.41-9.845 9.827 0 5.418 4.417 9.827 9.845 9.827 5.428 0 9.846-4.41 9.846-9.827s-4.418-9.826-9.846-9.826m0 30.18c-11.244 0-20.4-9.131-20.4-20.354C58.571 9.124 67.727 0 78.971 0c11.245 0 20.402 9.124 20.402 20.347s-9.157 20.355-20.402 20.355M128.55 55.6c-5.429 0-9.846 4.408-9.846 9.825 0 5.418 4.417 9.827 9.845 9.827 5.429 0 9.846-4.409 9.846-9.827 0-5.417-4.417-9.826-9.846-9.826m0 30.181c-11.244 0-20.4-9.132-20.4-20.355 0-11.222 9.156-20.347 20.4-20.347 11.245 0 20.402 9.125 20.402 20.347 0 11.223-9.157 20.355-20.402 20.355M178.562 32.841c-5.43 0-9.848 4.409-9.848 9.826 0 5.418 4.418 9.827 9.848 9.827 5.429 0 9.847-4.409 9.847-9.827 0-5.417-4.418-9.826-9.847-9.826m0 30.181c-11.247 0-20.398-9.132-20.398-20.355 0-11.222 9.151-20.347 20.398-20.347 11.246 0 20.404 9.125 20.404 20.347 0 11.223-9.158 20.355-20.404 20.355",
        fill: "#FFF",
        className: "svg-fill-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M42.834 62.147a5.319 5.319 0 01-3.79-1.572 5.267 5.267 0 01.051-7.478l23.58-23.13a5.36 5.36 0 017.53.052c2.061 2.078 2.031 5.428-.052 7.484l-23.58 23.123a5.308 5.308 0 01-3.739 1.52M116.463 59.958a5.255 5.255 0 01-3.568-1.387l-23.65-21.766a5.33 5.33 0 01-.33-7.506 5.273 5.273 0 017.474-.332l23.642 21.758a5.34 5.34 0 01.33 7.514 5.252 5.252 0 01-3.898 1.72M143.735 64.335a5.301 5.301 0 01-4.778-2.976 5.277 5.277 0 012.456-7.07l17.889-8.67c2.64-1.293 5.818-.184 7.1 2.447a5.277 5.277 0 01-2.455 7.069l-17.896 8.67a5.222 5.222 0 01-2.316.53M202.445 178.562H5.523c-2.928 0-5.304-2.35-5.304-5.255 0-2.898 2.376-5.248 5.304-5.248h196.922c2.92 0 5.296 2.35 5.296 5.248 0 2.905-2.376 5.255-5.296 5.255M211.69 173.526c0-2.778 2.257-5.03 5.049-5.03a5.036 5.036 0 015.042 5.03 5.038 5.038 0 01-5.042 5.036 5.04 5.04 0 01-5.05-5.036",
        fill: "#FFF",
        className: "svg-fill-secondary"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M28.946 60.849a9.816 9.816 0 00-6.574 2.507c-4.039 3.62-4.383 9.842-.755 13.878a9.838 9.838 0 006.8 3.254c2.632.234 5.16-.738 7.11-2.5 4.046-3.613 4.39-9.842.762-13.878a9.846 9.846 0 00-7.343-3.261m.029 30.183c-.374 0-.748-.015-1.129-.03-5.445-.3-10.444-2.69-14.086-6.741-7.512-8.35-6.809-21.248 1.568-28.743 8.377-7.48 21.298-6.792 28.81 1.55 0 .008.008.008.008.008a20.23 20.23 0 015.181 14.696 20.177 20.177 0 01-6.75 14.054 20.288 20.288 0 01-13.602 5.206",
      fill: "#4BAF5E",
      className: "svg-fill-primary"
    })]
  })]
});

CombinedChartIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(CombinedChartIcon);

exports.default = _default;